import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import i18n from './i18n/index'
import vueSeamlessScroll from 'vue-seamless-scroll'
import VueMeta from 'vue-meta'
import MetaInfo from 'vue-meta-info'
// 全局注册组件
Vue.component('HomePage', () => import('@/components/Home/HomePage.vue'))
Vue.use(MetaInfo)
Vue.use(ElementUI)
Vue.use(vueSeamlessScroll)
Vue.use(VueMeta)

// 响应式根字体大小设置
// const setRootFontSize = () => {
//   const width = document.documentElement.clientWidth
//   document.documentElement.style.fontSize = width < 768 ? `${width / 37.5}px` : '16px'
// }
// window.addEventListener('resize', setRootFontSize)
// setRootFontSize()


new Vue({
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')
